/**
 * @Des 授权 弹出层
 * @Auth
 * @Date 
 */

/* HTML */
<template>
    <el-dialog :title="dialogForm.title"
               :visible.sync="dialogForm.dialogFormVisible"
               :close-on-click-modal="false"
               custom-class="form-dialog"
               v-dialogDrag
               class="dialog_title"
               @close="handleDialogClose"
    >

        <el-form label-width="100px" ref="dialogRowForm" :rules="rules" :model="dialogRowForm">
            <el-form-item label="申请码：" prop="requestCode" style="margin-bottom: 0px;">
              <span slot="label" style="line-height: 40px;">
                <span>申请码</span>
                <span class="el-icon-copy-document"
                  v-clipboard:copy="dialogRowForm.requestCode"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  title="复制申请码" >复制</span>
              </span>
              <el-input v-model="dialogRowForm.requestCode" type="textarea" :autosize="{minRows: 4, maxRows: 10}" placeholder="申请码" :readonly="true"/>
            </el-form-item>
            <el-form-item ><span style="font-size: 12px;letter-spacing: 2px;">（温馨提示：请将申请码发送给管理员，以获取授权码）</span></el-form-item>
            <el-form-item label="授权码" prop="authCode">
            	<el-input v-model="dialogRowForm.authCode" type="textarea" :autosize="{minRows: 4, maxRows: 10}" placeholder="请输入授权码" clearable/>
            </el-form-item>
            <el-form-item class="btn-form-item-c">
                <el-button type="primary" size="primary" @click="submitForm()">{{dialogForm.submitButton}}</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>

</template>

<script>
    // 组件 文本加密
    import Secret from '@/secret';
    // 组件 校验
    import {validFormat, checkFormat} from '@/global/global-valid';
    
    // API oam
    import ApiOam from '@/request/api-oam'

    export default {
        /**
         * @Des 组件名
         * @Auth
         * @Date 
         */
        name: 'WarrantDialog',
        /**
         * @Des 数据接收类型
         * @Auth
         * @Date 
         */
        props: {
            /**
             * @Des 公钥
             * @Auth
             * @Date 
             */
			publicKey: {
				type: String,
				default: function (){
					return '';
				}
			},
        },
        /**
         * @Des 组件引用
         * @Auth
         * @Date 
         */
        components: {
            
        },
        /**
         * @Des 销毁
         * @Auth
         * @Date 
         */
		beforeDestroy() {
			
		},
        /**
         * @Des 数据定义
         * @Auth
         * @Date 
         */
        data() {
            return {
                /**
                 * @Des 弹出层属性
                 * @Auth
                 * @Date 
                 */
                dialogForm: {
                    title: '',
                    dialogFormVisible: false,
                    submitButton: ''
                },
                
                /**
                 * @Des 表单
                 * @Auth
                 * @Date 
                 */
                dialogRowForm: {
                	// 申请码
                	requestCode: '',
                    // 授权码
                    authCode: '',
                },

                /**
                 * @Des 弹窗规则
                 * @Auth
                 * @Date 
                 */
                rules: {
                    authCode: [
                        { required: true, message: '授权码不能为空', trigger: 'blur' }
                    ],
                },// rules
                
                // 交互锁
                locked: false,
            }
        },
        /**
         * @Des 方法定义
         * @Auth
         * @Date 
         */
        methods: {
            // 复制到剪切板
            onCopy() {
            	this.$message({message: '申请码复制成功',type: 'success'});
            },
            onError() {
            	this.$message.error('复制失败');
            },
            
            /**
             * @Des 打开账户弹窗
             * @Auth
             * @Date 
             */
            openDialog(data) {
                // console.log(data);
                this.dialogForm.dialogFormVisible = true;

                this.dialogForm.title = '平台授权';
                this.dialogForm.submitButton = "提交";
                
                if (!this.$checkEmpty(data)) {
	                // 表单
	                this.dialogRowForm = Object.assign({}, this.dialogRowForm, data);
                }
                
                // 延迟执行
                this.$nextTick(() => {
                	// 查询服务器信息
            		this.initRequestCode();
                });

            },
			
			/**
             * @Des 查询服务器信息
             * @Auth
             * @Date 
             */
            initRequestCode() {
            	let requestStr = [this.$store.state.uuid, this.dialogRowForm.projectId].join(',');
            	// 申请码
            	this.dialogRowForm.requestCode = Secret.encryptRSA(requestStr, this.$store.state.authKey);
            },
			
            /**
             * @Des 提交账户信息
             * @Auth
             * @Date 
             */
            submitForm() {
                // 交互锁
				if (this.locked) return false;
                
                // 表单校验
                this.$refs.dialogRowForm.validate(valid => {
                    if(!valid) return false;
                    
                    // 交互参数
                    let params = {
                    	projectId: this.dialogRowForm.projectId,
                    	// 申请码
                    	requestCode: this.dialogRowForm.requestCode,
		                // 授权码
		                authCode: this.dialogRowForm.authCode,
		                systemType: 2,// 1运维平台	2 应用平台
                    };

                    // 交互 路径
                    let submitApi = ApiOam.Save_Auth_Code_Uri;
                    
                    // 交互锁
                    this.locked = true;
                    // 数据交互
                    this.$request.postJsonRequest(submitApi, params).then(result => {
                        if(result.code == 0){
                            let message = '授权成功';
                            this.$message({
                                message: message,
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            // 关闭弹窗
                            this.dialogForm.dialogFormVisible = false;
                            
                            // 存储登录信息
                            this.$emit('storeLoginInfo');
                            
                        }else{
                            this.$message({
                                message: '授权异常：' + result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                        
                        // 交互锁
                        this.locked = false;
                    }).catch(error => {
                    	// 交互锁
                    	this.locked = false;
                        console.error('授权异常', submitApi, error);
                    })
                });// validata
            },
            
            /**
	         * @Des 关闭弹窗
	         * @Auth
	         * @Date 
	         */
	        handleDialogClose() {
	            // 重置表单
	            this.reset();
	            // 回调
				this.$emit('callback');
	        },

            /**
	         * @Des 重置方法
	         * @Auth 
	         * @Date 
	         */
	        reset() {
	            // 清除表单数据
	            this.cleanData(this.dialogRowForm);
	            // 清除表单验证
	            this.cleanValidate('dialogRowForm');
	        },

            /**
             * @Des 清除验证信息
             * @Auth
             * @Date 
             */
            cleanValidate(formName) {
                // 清除表单校验的提示
                if (this.$refs[formName]) {
                    // 延时执行
                    this.$nextTick(function () {
                        this.$refs[formName].clearValidate();
                    })
                };
            },
            /**
	         * @Des 清除数据
	         * @Auth
	         * @Date 
	         */
	        cleanData(form) {
	            // 延时执行
	            this.$nextTick(function () {
	                // 申请码
	                form.requestCode = '';
	                // 授权码
					form.authCode = '';
	            });// 延时执行
	        },
        },// methods

    }
</script>
/* JS */

/* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog {
		border: 1px solid #fff;
		border-radius: 4px;
		/*background-color: #151c2e;*/
		background-color: #1f4197;
		
		.el-form-item__label {
			line-height: 20px;
		}
	}
	/deep/ .form-dialog .el-dialog__header {
		background-color: rgba(0, 0, 0, 0);
		border-color: #fff;
	}
	/deep/ .el-textarea__inner {
		font-size: 16px;
		line-height: 22px;
		padding: 10px;
		color: #cdcece;
		background-color: rgba(9, 9, 9, 0.12);
	}
	
	/deep/ .copy-clipboard-btn {
		float: right;
		margin: 10px 10px 0 0;
		border: 1px solid #ccc;
		border-radius: 2px;
		padding: 2px 4px;
		font-size: 12px;
		cursor: pointer;
		
		transition: all 0.4s;
		
		&:active {
			border-color: dodgerblue;
		}
	}
	
</style>



// WEBPACK FOOTER //
// src/components_index/License/WarrantDialog.vue